// Dependencies
import React, { Component } from 'react';
import { getLanguage, withTranslation } from 'react-multi-lang';

// Primereact imports
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

// Styling
import './other-training-data.scss';

// Utils
import { OTHER_QUALIFICATION } from '../../../../common/constants';
import { formatAssociateDataToService } from '../../../../common/formatters/associate';
import { getOtherTrainingList, getTranslatedOtherTrainingOption } from '../../../../common/lists/qualification';

// Redux
import { connect } from 'react-redux';
import { getAssociateData, setEditMode } from '../../../../redux/actions/profile';
import ProfileService from '../../../../redux/services/profile';

class OtherTrainingDataComponent extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            mentalHealth: null,
            occupationHealth: null,
            womenHealth: null,
            wellBeingHealth: null,
            promotionProtectionHealth: null,
            muscleHealth: null,
            neuroHealth: null,
            heartHealth: null,
            respiratoryHealth: null,
            integumentalHealth: null,
            oncologicalHealth: null,
            animalHealth: null,
            complexScenarios: null,
            otherConditions: null,
            readOnlyMode: true
        };
    }

    componentDidMount() {
        this.setState({
            mentalHealth: this.props.associate.healthQualification.mentalHealth,
            occupationHealth: this.props.associate.healthQualification.occupationHealth,
            womenHealth: this.props.associate.healthQualification.womenHealth,
            wellBeingHealth: this.props.associate.healthQualification.wellBeingHealth,
            promotionProtectionHealth: this.props.associate.healthQualification.promotionProtectionHealth,
            muscleHealth: this.props.associate.healthQualification.muscleHealth,
            neuroHealth: this.props.associate.healthQualification.neuroHealth,
            heartHealth: this.props.associate.healthQualification.heartHealth,
            respiratoryHealth: this.props.associate.healthQualification.respiratoryHealth,
            integumentalHealth: this.props.associate.healthQualification.integumentalHealth,
            oncologicalHealth: this.props.associate.healthQualification.oncologicalHealth,
            animalHealth: this.props.associate.healthQualification.animalHealth,
            complexScenarios: this.props.associate.healthQualification.complexScenarios,
            otherConditions: this.props.associate.healthQualification.otherConditions
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.language !== prevProps.language) {
            let associate = this.formatQualificationOtherDataFormValues(this.props.associate, this.props.language);

            this.setState({
                mentalHealth: associate.healthQualification.mentalHealth,
                occupationHealth: associate.healthQualification.occupationHealth,
                womenHealth: associate.healthQualification.womenHealth,
                wellBeingHealth: associate.healthQualification.wellBeingHealth,
                promotionProtectionHealth: associate.healthQualification.promotionProtectionHealth,
                muscleHealth: associate.healthQualification.muscleHealth,
                neuroHealth: associate.healthQualification.neuroHealth,
                heartHealth: associate.healthQualification.heartHealth,
                respiratoryHealth: associate.healthQualification.respiratoryHealth,
                integumentalHealth: associate.healthQualification.integumentalHealth,
                oncologicalHealth: associate.healthQualification.oncologicalHealth,
                animalHealth: associate.healthQualification.animalHealth,
                complexScenarios: associate.healthQualification.complexScenarios,
                otherConditions: associate.healthQualification.otherConditions
            });
        }
    }
    
    activateEditMode() {
        this.setState({
            readOnlyMode: false
        });

        this.props.setEditMode(true);
    }

    cancelEditMode() {
        let associate = this.formatQualificationOtherDataFormValues(this.props.associate, this.props.language);

        this.setState({
            mentalHealth: associate.healthQualification.mentalHealth,
            occupationHealth: associate.healthQualification.occupationHealth,
            womenHealth: associate.healthQualification.womenHealth,
            wellBeingHealth: associate.healthQualification.wellBeingHealth,
            promotionProtectionHealth: associate.healthQualification.promotionProtectionHealth,
            muscleHealth: associate.healthQualification.muscleHealth,
            neuroHealth: associate.healthQualification.neuroHealth,
            heartHealth: associate.healthQualification.heartHealth,
            respiratoryHealth: associate.healthQualification.respiratoryHealth,
            integumentalHealth: associate.healthQualification.integumentalHealth,
            oncologicalHealth: associate.healthQualification.oncologicalHealth,
            animalHealth: associate.healthQualification.animalHealth,
            complexScenarios: associate.healthQualification.complexScenarios,
            otherConditions: associate.healthQualification.otherConditions,
            readOnlyMode: true
        });
        this.props.setEditMode(false);
    }

    saveChanges() {
        let associate = this.props.associate;
        associate.healthQualification = {
            mentalHealth: this.state.mentalHealth,
            occupationHealth: this.state.occupationHealth,
            womenHealth: this.state.womenHealth,
            wellBeingHealth: this.state.wellBeingHealth,
            promotionProtectionHealth: this.state.promotionProtectionHealth,
            muscleHealth: this.state.muscleHealth,
            neuroHealth: this.state.neuroHealth,
            heartHealth: this.state.heartHealth,
            respiratoryHealth: this.state.respiratoryHealth,
            integumentalHealth: this.state.integumentalHealth,
            oncologicalHealth: this.state.oncologicalHealth,
            animalHealth: this.state.animalHealth,
            complexScenarios: this.state.complexScenarios,
            otherConditions: this.state.otherConditions
        };

        ProfileService.updateAssociateData(formatAssociateDataToService(associate), this.props.t('general.update-record'), OTHER_QUALIFICATION)
        .then((response) => {
            this.setState({
                readOnlyMode: true
            });

            this.props.setEditMode(false);

            this.props.getAssociateData(this.props.registrationRef);

            setTimeout(() => {
                let associate = this.formatQualificationOtherDataFormValues(this.props.associate, this.props.language);

                this.setState({
                    mentalHealth: associate.healthQualification.mentalHealth,
                    occupationHealth: associate.healthQualification.occupationHealth,
                    womenHealth: associate.healthQualification.womenHealth,
                    wellBeingHealth: associate.healthQualification.wellBeingHealth,
                    promotionProtectionHealth: associate.healthQualification.promotionProtectionHealth,
                    muscleHealth: associate.healthQualification.muscleHealth,
                    neuroHealth: associate.healthQualification.neuroHealth,
                    heartHealth: associate.healthQualification.heartHealth,
                    respiratoryHealth: associate.healthQualification.respiratoryHealth,
                    integumentalHealth: associate.healthQualification.integumentalHealth,
                    oncologicalHealth: associate.healthQualification.oncologicalHealth,
                    animalHealth: associate.healthQualification.animalHealth,
                    complexScenarios: associate.healthQualification.complexScenarios,
                    otherConditions: associate.healthQualification.otherConditions
                });
                
                /*this.setState({
                    mentalHealth: this.props.associate.healthQualification.mentalHealth,
                    occupationHealth: this.props.associate.healthQualification.occupationHealth,
                    womenHealth: this.props.associate.healthQualification.womenHealth,
                    wellBeingHealth: this.props.associate.healthQualification.wellBeingHealth,
                    promotionProtectionHealth: this.props.associate.healthQualification.promotionProtectionHealth,
                    muscleHealth: this.props.associate.healthQualification.muscleHealth,
                    neuroHealth: this.props.associate.healthQualification.neuroHealth,
                    heartHealth: this.props.associate.healthQualification.heartHealth,
                    respiratoryHealth: this.props.associate.healthQualification.respiratoryHealth,
                    integumentalHealth: this.props.associate.healthQualification.integumentalHealth,
                    oncologicalHealth: this.props.associate.healthQualification.oncologicalHealth,
                    animalHealth: this.props.associate.healthQualification.animalHealth,
                    complexScenarios: this.props.associate.healthQualification.complexScenarios,
                    otherConditions: this.props.associate.healthQualification.otherConditions
                });*/
            }, 1500);
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
        });
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: value
        });
    }

    formatQualificationOtherDataFormValues(sourceAssociate, language = "pt") {
        let associate = {
            healthQualification: {}
        };
    
        if(typeof sourceAssociate.healthQualification.animalHealth  !== 'object' && sourceAssociate.healthQualification.animalHealth !== null) {
            associate.healthQualification.animalHealth = { name: associate.healthQualification.animalHealth, code: associate.healthQualification.animalHealth };
        }
        else if (typeof sourceAssociate.healthQualification.animalHealth === 'object' && sourceAssociate.healthQualification.animalHealth !== null) {
            associate.healthQualification.animalHealth = getTranslatedOtherTrainingOption(sourceAssociate.healthQualification.animalHealth.code, language);
        }
    
        if(typeof sourceAssociate.healthQualification.complexScenarios  !== 'object' && sourceAssociate.healthQualification.complexScenarios !== null) {
            associate.healthQualification.complexScenarios = { name: associate.healthQualification.complexScenarios, code: associate.healthQualification.complexScenarios };
        }
        else if (typeof sourceAssociate.healthQualification.complexScenarios === 'object' && sourceAssociate.healthQualification.complexScenarios !== null) {
            associate.healthQualification.complexScenarios = getTranslatedOtherTrainingOption(sourceAssociate.healthQualification.complexScenarios.code, language);
        }
    
        if(typeof sourceAssociate.healthQualification.heartHealth  !== 'object' && sourceAssociate.healthQualification.heartHealth !== null) {
            associate.healthQualification.heartHealth = { name: associate.healthQualification.heartHealth, code: associate.healthQualification.heartHealth };
        }
        else if (typeof sourceAssociate.healthQualification.heartHealth === 'object' && sourceAssociate.healthQualification.heartHealth !== null) {
            associate.healthQualification.heartHealth = getTranslatedOtherTrainingOption(sourceAssociate.healthQualification.heartHealth.code, language);
        }
    
        if(typeof sourceAssociate.healthQualification.integumentalHealth  !== 'object' && sourceAssociate.healthQualification.integumentalHealth !== null) {
            associate.healthQualification.integumentalHealth = { name: associate.healthQualification.integumentalHealth, code: associate.healthQualification.integumentalHealth };
        }
        else if (typeof sourceAssociate.healthQualification.integumentalHealth === 'object' && sourceAssociate.healthQualification.integumentalHealth !== null) {
            associate.healthQualification.integumentalHealth = getTranslatedOtherTrainingOption(sourceAssociate.healthQualification.integumentalHealth.code, language);
        }
    
        if(typeof sourceAssociate.healthQualification.mentalHealth  !== 'object' && sourceAssociate.healthQualification.mentalHealth !== null) {
            associate.healthQualification.mentalHealth = { name: associate.healthQualification.mentalHealth, code: associate.healthQualification.mentalHealth };
        }
        else if (typeof sourceAssociate.healthQualification.mentalHealth === 'object' && sourceAssociate.healthQualification.mentalHealth !== null) {
            associate.healthQualification.mentalHealth = getTranslatedOtherTrainingOption(sourceAssociate.healthQualification.mentalHealth.code, language);
        }
    
        if(typeof sourceAssociate.healthQualification.muscleHealth  !== 'object' && sourceAssociate.healthQualification.muscleHealth !== null) {
            associate.healthQualification.muscleHealth = { name: associate.healthQualification.muscleHealth, code: associate.healthQualification.muscleHealth };
        }
        else if (typeof sourceAssociate.healthQualification.muscleHealth === 'object' && sourceAssociate.healthQualification.muscleHealth !== null) {
            associate.healthQualification.muscleHealth = getTranslatedOtherTrainingOption(sourceAssociate.healthQualification.muscleHealth.code, language);
        }
    
        if(typeof sourceAssociate.healthQualification.neuroHealth  !== 'object' && sourceAssociate.healthQualification.neuroHealth !== null) {
            associate.healthQualification.neuroHealth = { name: associate.healthQualification.neuroHealth, code: associate.healthQualification.neuroHealth };
        }
        else if (typeof sourceAssociate.healthQualification.neuroHealth === 'object' && sourceAssociate.healthQualification.neuroHealth !== null) {
            associate.healthQualification.neuroHealth = getTranslatedOtherTrainingOption(sourceAssociate.healthQualification.neuroHealth.code, language);
        }
    
        if(typeof sourceAssociate.healthQualification.occupationHealth  !== 'object' && sourceAssociate.healthQualification.occupationHealth !== null) {
            associate.healthQualification.occupationHealth = { name: associate.healthQualification.occupationHealth, code: associate.healthQualification.occupationHealth };
        }
        else if (typeof sourceAssociate.healthQualification.occupationHealth === 'object' && sourceAssociate.healthQualification.occupationHealth !== null) {
            associate.healthQualification.occupationHealth = getTranslatedOtherTrainingOption(sourceAssociate.healthQualification.occupationHealth.code, language);
        }
        
        if(typeof sourceAssociate.healthQualification.oncologicalHealth  !== 'object' && sourceAssociate.healthQualification.oncologicalHealth !== null) {
            associate.healthQualification.oncologicalHealth = { name: associate.healthQualification.oncologicalHealth, code: associate.healthQualification.oncologicalHealth };
        }
        else if (typeof sourceAssociate.healthQualification.oncologicalHealth === 'object' && sourceAssociate.healthQualification.oncologicalHealth !== null) {
            associate.healthQualification.oncologicalHealth = getTranslatedOtherTrainingOption(sourceAssociate.healthQualification.oncologicalHealth.code, language);
        }
    
        if(typeof sourceAssociate.healthQualification.otherConditions  !== 'object' && sourceAssociate.healthQualification.otherConditions !== null) {
            associate.healthQualification.otherConditions = { name: associate.healthQualification.otherConditions, code: associate.healthQualification.otherConditions };
        }
        else if (typeof sourceAssociate.healthQualification.otherConditions === 'object' && sourceAssociate.healthQualification.otherConditions !== null) {
            associate.healthQualification.otherConditions = getTranslatedOtherTrainingOption(sourceAssociate.healthQualification.otherConditions.code, language);
        }
    
        if(typeof sourceAssociate.healthQualification.promotionProtectionHealth  !== 'object' && sourceAssociate.healthQualification.promotionProtectionHealth !== null) {
            associate.healthQualification.promotionProtectionHealth = { name: associate.healthQualification.promotionProtectionHealth, code: associate.healthQualification.promotionProtectionHealth };
        }
        else if (typeof sourceAssociate.healthQualification.promotionProtectionHealth === 'object' && sourceAssociate.healthQualification.promotionProtectionHealth !== null) {
            associate.healthQualification.promotionProtectionHealth = getTranslatedOtherTrainingOption(sourceAssociate.healthQualification.promotionProtectionHealth.code, language);
        }
       
        if(typeof sourceAssociate.healthQualification.respiratoryHealth  !== 'object' && sourceAssociate.healthQualification.respiratoryHealth !== null) {
            associate.healthQualification.respiratoryHealth = { name: associate.healthQualification.respiratoryHealth, code: associate.healthQualification.respiratoryHealth };
        }
        else if (typeof sourceAssociate.healthQualification.respiratoryHealth === 'object' && sourceAssociate.healthQualification.respiratoryHealth !== null) {
            associate.healthQualification.respiratoryHealth = getTranslatedOtherTrainingOption(sourceAssociate.healthQualification.respiratoryHealth.code, language);
        }
    
        if(typeof sourceAssociate.healthQualification.wellBeingHealth  !== 'object' && sourceAssociate.healthQualification.wellBeingHealth !== null) {
            associate.healthQualification.wellBeingHealth = { name: associate.healthQualification.wellBeingHealth, code: associate.healthQualification.wellBeingHealth };
        }
        else if (typeof sourceAssociate.healthQualification.wellBeingHealth === 'object' && sourceAssociate.healthQualification.wellBeingHealth !== null) {
            associate.healthQualification.wellBeingHealth = getTranslatedOtherTrainingOption(sourceAssociate.healthQualification.wellBeingHealth.code, language);
        }
    
        if(typeof sourceAssociate.healthQualification.womenHealth  !== 'object' && sourceAssociate.healthQualification.womenHealth !== null) {
            associate.healthQualification.womenHealth = { name: associate.healthQualification.womenHealth, code: associate.healthQualification.womenHealth };
        }
        else if (typeof sourceAssociate.healthQualification.womenHealth === 'object' && sourceAssociate.healthQualification.womenHealth !== null) {
            associate.healthQualification.womenHealth = getTranslatedOtherTrainingOption(sourceAssociate.healthQualification.womenHealth.code, language);
        }
    
        return associate;
    }

  render() {

    return (
        this.props.associate !== null && this.props.associate.healthQualification !== null ? 
            <div className='grid'>
                <div className='col-12'>
                    <div className="card p-fluid mgt-20">
                        <div className='grid'>
                            <div className='col-12 t-align-right'>
                                {
                                    this.state.readOnlyMode === true ? 
                                        <Button icon="pi pi-pencil" className="p-button-rounded mr-2 mb-2" disabled={!this.props.registrationApproved} onClick={() => this.activateEditMode()} />
                                        :   
                                        <>
                                            <Button icon="pi pi-check" className="p-button-rounded p-button-success mr-2 mb-2" onClick={() => this.saveChanges()} />
                                            <Button icon="pi pi-ban" className="p-button-rounded p-button-danger mr-2 mb-2" onClick={() => this.cancelEditMode()} />
                                        </>
                                }
                            </div>
                            <div className='col-12 t-align-left'>
                                <span>
                                    <b>{this.props.t("profile.areas.qualification.areas.other.form-title")}</b>
                                </span>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="actMentalHealth">{this.props.t("profile.areas.qualification.areas.other.mental-health")} <span className="invalid-message">*</span></label>
                                <Dropdown id="actMentalHealth" value={this.state.mentalHealth} disabled={this.state.readOnlyMode} options={getOtherTrainingList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("mentalHealth", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="actOcupHealth">{this.props.t("profile.areas.qualification.areas.other.ocup-health")} <span className="invalid-message">*</span></label>
                                <Dropdown id="actOcupHealth" value={this.state.occupationHealth} disabled={this.state.readOnlyMode} options={getOtherTrainingList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("occupationHealth", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="actWomenHealth">{this.props.t("profile.areas.qualification.areas.other.women-health")} <span className="invalid-message">*</span></label>
                                <Dropdown id="actWomenHealth" value={this.state.womenHealth} disabled={this.state.readOnlyMode} options={getOtherTrainingList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("womenHealth", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="wellHeatlh">{this.props.t("profile.areas.qualification.areas.other.well-health")} <span className="invalid-message">*</span></label>
                                <Dropdown id="wellHeatlh" value={this.state.wellBeingHealth} disabled={this.state.readOnlyMode} options={getOtherTrainingList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("wellBeingHealth", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="promotionHealth">{this.props.t("profile.areas.qualification.areas.other.promotion-health")} <span className="invalid-message">*</span></label>
                                <Dropdown id="promotionHealth" value={this.state.promotionProtectionHealth} disabled={this.state.readOnlyMode} options={getOtherTrainingList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("promotionProtectionHealth", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="muscleHealth">{this.props.t("profile.areas.qualification.areas.other.muscle-health")} <span className="invalid-message">*</span></label>
                                <Dropdown id="muscleHealth" value={this.state.muscleHealth} disabled={this.state.readOnlyMode} options={getOtherTrainingList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("muscleHealth", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="neuroHealth">{this.props.t("profile.areas.qualification.areas.other.neuro-health")} <span className="invalid-message">*</span></label>
                                <Dropdown id="neuroHealth" value={this.state.neuroHealth} disabled={this.state.readOnlyMode} options={getOtherTrainingList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("neuroHealth", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="cardioHealth">{this.props.t("profile.areas.qualification.areas.other.cardio-health")} <span className="invalid-message">*</span></label>
                                <Dropdown id="cardioHealth" value={this.state.heartHealth} disabled={this.state.readOnlyMode} options={getOtherTrainingList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("heartHealth", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="respiratoryHealth">{this.props.t("profile.areas.qualification.areas.other.respiratory-health")} <span className="invalid-message">*</span></label>
                                <Dropdown id="respiratoryHealth" value={this.state.respiratoryHealth} disabled={this.state.readOnlyMode} options={getOtherTrainingList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("respiratoryHealth", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="teguHealth">{this.props.t("profile.areas.qualification.areas.other.tegu-health")} <span className="invalid-message">*</span></label>
                                <Dropdown id="teguHealth" value={this.state.integumentalHealth} options={getOtherTrainingList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("integumentalHealth", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="oncoHealth">{this.props.t("profile.areas.qualification.areas.other.onco-health")} <span className="invalid-message">*</span></label>
                                <Dropdown id="oncoHealth" value={this.state.oncologicalHealth} disabled={this.state.readOnlyMode} options={getOtherTrainingList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("oncologicalHealth", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="animalHealth">{this.props.t("profile.areas.qualification.areas.other.animal-health")} <span className="invalid-message">*</span></label>
                                <Dropdown id="animalHealth" value={this.state.animalHealth} disabled={this.state.readOnlyMode} options={getOtherTrainingList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("animalHealth", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                <label htmlFor="complexSituations">{this.props.t("profile.areas.qualification.areas.other.complex-situations")} <span className="invalid-message">*</span></label>
                                <Dropdown id="complexSituations" value={this.state.complexScenarios} disabled={this.state.readOnlyMode} options={getOtherTrainingList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("complexScenarios", evt.value)}></Dropdown>
                            </div>
                            <div className='col-12 md:col-12 lg:col-4 t-align-left mgt-16'>
                                <label htmlFor="otherConditions">{this.props.t("profile.areas.qualification.areas.other.other-conditions")} <span className="invalid-message">*</span></label>
                                <Dropdown id="otherConditions" value={this.state.otherConditions} disabled={this.state.readOnlyMode} options={getOtherTrainingList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("otherConditions", evt.value)}></Dropdown>
                            </div>
                        </div>
                    </div>
                </div>
                <Toast position='bottom-left' ref={this._toast} />
            </div>
            : null
    );
  }
}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        registrationRef: state.authentication.registrationRef,
        registrationApproved: state.authentication.registrationApproved,
        language: state.profile.language
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        setEditMode: (editMode) => { dispatch(setEditMode(editMode)) },
        getAssociateData: (registrationRef) => { dispatch(getAssociateData(registrationRef)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(OtherTrainingDataComponent));